export interface HttpResponse<T> {
  res: T;
  status: boolean;
  message: string;
  data: T;
}

export interface UserHttpResponse<T> {
  status: boolean;
  message: string;
  data: T;
  token: string;
}

export interface SupportHttpResponse<T, K> {
  status: boolean;
  message: string;
  data: T;
  commentsdata: K;
}

export interface HttpGroupResponse<T, K> {
  status: boolean;
  message: string;
  data: T;
  clientdata: K;
}
